import React from 'react';
import { PulseLoader } from 'react-spinners';

const LoadingSpinner = ({ color, size }) => {
  return (
    <div className="SpinnerContainer">
      <PulseLoader color={color} size={size} />
    </div>
  );
};

export default LoadingSpinner;
